class CartaJuicio {
    constructor({codSeg, modelo, fechaGen, fechaEnvio, estado, fechaNovedad}) {
        this.codSeg = codSeg
        this.modelo = modelo
        this.fechaGen = fechaGen
        this.fechaEnvio = fechaEnvio
        this.estado = estado
        this.fechaNovedad = fechaNovedad
    }
}

export default CartaJuicio